import { Injectable } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { LcsDialogService } from 'src/app/common-components/dialog/dialog.service';
import { UserPasswordResetRequestComponent } from '../containers/user-password-reset-request.component';
import { UserPasswordResetRequestModel } from '../models/user-password-reset-request.model';
import { userPasswordResetRequestClose } from '../state/user-password-reset-request.actions';

@Injectable({ providedIn: 'root' })
export class UserPasswordResetRequestDialogService {
   private dialogRef: MatDialogRef<UserPasswordResetRequestComponent>;

   open(): MatDialogRef<UserPasswordResetRequestComponent> {
      this.dialogRef = this.dialogService.open<UserPasswordResetRequestComponent, UserPasswordResetRequestModel>(
         UserPasswordResetRequestComponent,
         {
            panelClass: ['dialog-lg', 'dialog-container'],
            closeOnNavigation: true,
         }
      );
      this.dialogRef.afterClosed().subscribe(() => {
         this.store.dispatch(userPasswordResetRequestClose());
      });
      return this.dialogRef;
   }

   close(): void {
      if (this.dialogRef) {
         this.dialogRef.close();
      }
   }

   constructor(private dialogService: LcsDialogService, private store: Store) {}
}
